import { createContext } from "react";

const GeoMapContext = createContext(null);
export default GeoMapContext;
